/* tslint:disable */
/* eslint-disable */
/**
 * Contract Management API
 * API for managing contracts
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateGroupContractCommand
 */
export interface UpdateGroupContractCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdateGroupContractCommand
     */
    statusId?: string;
    /**
     * 
     * @type {Date}
     * @memberof UpdateGroupContractCommand
     */
    effectiveDate?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof UpdateGroupContractCommand
     */
    endDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateGroupContractCommand
     */
    periodicityId?: string | null;
    /**
     * Notice period value (count of units).
     * @type {number}
     * @memberof UpdateGroupContractCommand
     */
    noticeDurationValue?: number | null;
    /**
     * Notice period unit (UnitesPreavis enum, 1=Days, 2=Weeks, 3=Months, 4=Years).
     * @type {number}
     * @memberof UpdateGroupContractCommand
     */
    noticeDurationUnit?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateGroupContractCommand
     */
    mainDueDateDay?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateGroupContractCommand
     */
    mainDueDateMonth?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateGroupContractCommand
     */
    partnerIdentifier?: string | null;
}

/**
 * Check if a given object implements the UpdateGroupContractCommand interface.
 */
export function instanceOfUpdateGroupContractCommand(value: object): value is UpdateGroupContractCommand {
    return true;
}

export function UpdateGroupContractCommandFromJSON(json: any): UpdateGroupContractCommand {
    return UpdateGroupContractCommandFromJSONTyped(json, false);
}

export function UpdateGroupContractCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateGroupContractCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'statusId': json['statusId'] == null ? undefined : json['statusId'],
        'effectiveDate': json['effectiveDate'] == null ? undefined : (new Date(json['effectiveDate'])),
        'endDate': json['endDate'] == null ? undefined : (new Date(json['endDate'])),
        'periodicityId': json['periodicityId'] == null ? undefined : json['periodicityId'],
        'noticeDurationValue': json['noticeDurationValue'] == null ? undefined : json['noticeDurationValue'],
        'noticeDurationUnit': json['noticeDurationUnit'] == null ? undefined : json['noticeDurationUnit'],
        'mainDueDateDay': json['mainDueDateDay'] == null ? undefined : json['mainDueDateDay'],
        'mainDueDateMonth': json['mainDueDateMonth'] == null ? undefined : json['mainDueDateMonth'],
        'partnerIdentifier': json['partnerIdentifier'] == null ? undefined : json['partnerIdentifier'],
    };
}

export function UpdateGroupContractCommandToJSON(json: any): UpdateGroupContractCommand {
    return UpdateGroupContractCommandToJSONTyped(json, false);
}

export function UpdateGroupContractCommandToJSONTyped(value?: UpdateGroupContractCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'statusId': value['statusId'],
        'effectiveDate': value['effectiveDate'] == null ? undefined : ((value['effectiveDate'] as any).toISOString()),
        'endDate': value['endDate'] == null ? undefined : ((value['endDate'] as any).toISOString()),
        'periodicityId': value['periodicityId'],
        'noticeDurationValue': value['noticeDurationValue'],
        'noticeDurationUnit': value['noticeDurationUnit'],
        'mainDueDateDay': value['mainDueDateDay'],
        'mainDueDateMonth': value['mainDueDateMonth'],
        'partnerIdentifier': value['partnerIdentifier'],
    };
}

